export const parseErrorContent = (e: any) => {
  return e?.response?.data?.message || 'Something went wrong, please refresh.';
};
